// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.profile.HpApiUserProfileV3Handler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { HpApiUserProfileV3Handler_update } from '@zg-rentals/ts-hotpads-api-client';

import type {
  HpApiResponseDto,
  HpUserProfileDto,
  HpUserProfileUpdateRequestDto,
} from '@zg-rentals/ts-hotpads-api-client';

export interface HpApiUserProfileV3Handler_update_Args {
  postData: HpUserProfileUpdateRequestDto;
}

export type HpApiUserProfileV3Handler_update_Options = UseMutationOptions<
  HpApiResponseDto<HpUserProfileDto>,
  unknown,
  HpApiUserProfileV3Handler_update_Args
>;

/**
 * Update the authenticated user's profile
 */
export const useHpApiUserProfileV3Handler_update = ({
  httpClient,
  ...options
}: Omit<HpApiUserProfileV3Handler_update_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: HpApiUserProfileV3Handler_update_Args) =>
      HpApiUserProfileV3Handler_update(args.postData, httpClient),
  });
};
